import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import qs from 'qs';

import {
  sendForm,
  selectRequestState,
  changeFieldPassword,
  changeFieldPasswordConfirm,
  selectFieldPassword,
  selectFieldPasswordConfirm,
  selectMessage
} from 'mt-react-common/modules/users/common/reducers/forms/resetPasswordForm';
import ButtonDefault from '../../Common/Buttons/ButtonDefault';

const resetPasswordFormRN = 'usersModule.forms.resetPasswordForm';

class ChangePassword extends Component {
  handleSubmit = async event => {
    event.preventDefault();
    this.props.sendForm();
  };

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };

    if (this.props.requestState.hasSuccessQuery) {
      return (
        <div className="alert alert-success">
          <span>{this.props.selectMessage}</span>
        </div>
      );
    }
    return (
      <div>
        <p className="text-center">Введите ваш новый пароль:</p>
        <form onSubmit={this.handleSubmit}>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldPassword.errors) ? 'has-error' : ''
            }`}
          >
            <input
              type="password"
              className="form-control input-lg"
              id="inputName"
              placeholder="Пароль"
              value={this.props.selectFieldPassword.value}
              onChange={e => {
                this.props.changeFieldPassword(e.target.value);
              }}
            />
            {errorDesc(this.props.selectFieldPassword.errors)}
          </div>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldPasswordConfirm.errors)
                ? 'has-error'
                : ''
            }`}
          >
            <input
              type="password"
              className="form-control input-lg"
              id="inputName"
              placeholder="Повторите пароль"
              value={this.props.selectFieldPasswordConfirm.value}
              onChange={e => {
                this.props.changeFieldPasswordConfirm(e.target.value);
              }}
            />
            {errorDesc(this.props.selectFieldPasswordConfirm.errors)}
          </div>
          <ButtonDefault
            type="submit"
            buttonTitle={'Изменить пароль'}
            showLoading={this.props.requestState.hasInProgress}
            disabled={this.props.requestState.hasInProgress}
          />
        </form>
      </div>
    );
  }
}

ChangePassword.propTypes = {
  // CONNECT
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  selectFieldPassword: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectFieldPasswordConfirm: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectMessage: PropTypes.string.isRequired,

  changeFieldPassword: PropTypes.func.isRequired,
  changeFieldPasswordConfirm: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, resetPasswordFormRN),
  selectFieldPassword: selectFieldPassword(state, resetPasswordFormRN),
  selectFieldPasswordConfirm: selectFieldPasswordConfirm(
    state,
    resetPasswordFormRN
  ),
  selectMessage: selectMessage(state, resetPasswordFormRN)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldPassword: value =>
    dispatch(changeFieldPassword(resetPasswordFormRN, value)),
  changeFieldPasswordConfirm: value =>
    dispatch(changeFieldPasswordConfirm(resetPasswordFormRN, value)),
  sendForm: () =>
    dispatch(
      sendForm(
        resetPasswordFormRN,
        _.get(qs.parse(props.location.search.slice(1)), 'token')
      )
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChangePassword)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/ChangePassword/ChangePassword.js